// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"27":"a97a5477","80":"78a03bd7","358":"31944c43","496":"910861a7","748":"a6ad9cf0","763":"db0b2d7b","835":"9e531edc","926":"31f11934"}[chunkId] + ".chunk.js";
};